export class ReferenceDataCaseStatus {
  public static readonly Name = 'CaseStatus';
  public static readonly KfiIncomplete = 'KFIIncomplete';
  public static readonly KfiIssued = 'KFIIssued';
  public static readonly KfiNotProceeding = 'KFINotProceeding';
  public static readonly AipAccepted = 'AipAccepted';
  public static readonly AipDeclined = 'AipDeclined';
  public static readonly AipDuplicate = 'AipDuplicate';
  public static readonly AipError = 'AipError';
  public static readonly AipIncomplete = 'AipIncomplete';
  public static readonly AipNotProceeding = 'AipNotProceeding';
  public static readonly AipReferred = 'AipReferred';
  public static readonly AipWithUnderwriter = 'AipWithUnderwriter';
  public static readonly AppAccepted = 'AppAccepted';
  public static readonly AppAcceptedPendingPayment = 'AppAcceptedPendingPayment';
  public static readonly AppDeclined = 'AppDeclined';
  public static readonly AppDuplicate = 'AppDuplicate';
  public static readonly AppError = 'AppError';
  public static readonly AppIncomplete = 'AppIncomplete';
  public static readonly AppNotProceeding = 'AppNotProceeding';
  public static readonly AppReceived = 'AppReceived';
  public static readonly AppReferred = 'AppReferred';
  public static readonly AppSubmitted = 'AppSubmitted';
  public static readonly AppWithUnderwriter = 'AppWithUnderwriter';
  public static readonly AwaitingDocuments = 'AwaitingDocuments';
  public static readonly DeterminingSupportingDocuments = 'DeterminingSupportingDocuments';
  public static readonly ReadyForReview = 'ReadyForReview';
  public static readonly SamCompleted = 'COMPLETED';
  public static readonly SamDayOneDate = 'DAYONEDATE';
  public static readonly SamDeclined = 'DECLINED';
  public static readonly SamDropped = 'DROPPED';
  public static readonly SamFundsReleased = 'FUNDSRELEASED';
  public static readonly SamOffPrint = 'OFFPRINT';
  public static readonly SamReinstate = 'REINSTATE';
  public static readonly SamRot = 'ROT';
  public static readonly SamValucomp = 'VALUCOMP';
  public static readonly SamAwaitingAssessment = 'APPSTART';
  public static readonly MovedToAdvised = 'MovedToAdvised';
  public static readonly MaterialChangeReview = 'MaterialChangeReview';
  public static readonly GatheringAdviceData = 'GatheringAdviceData';
  public static readonly RecommendationMade = 'RecommendationMade';
  public static readonly WithAdvisor = 'WithAdvisor';
  public static readonly AdviceNotProceeding = 'AdviceNotProceeding';
  public static readonly AwaitingCustomer = 'AwaitingCustomer';
  public static readonly FF1Complete = 'FF1Complete';
  public static readonly FF1Declined = 'FF1Declined';
  public static readonly FF1Incomplete = 'FF1Incomplete';
}
